import React from 'react'
import { Link } from "react-router-dom";


const Faq = () => {
  return (
    <>
      <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
        <div className="container">
          <div className="dz-bnr-inr-entry d-table-cell">
            <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>FAQ</h1>
            <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
              <ul className="">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item">FAQ</li>
              </ul>
            </nav>
            <div className="dz-btn">
              <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                <span className="left-icon">
                  <i className="feather icon-phone-call" />
                </span>
                +91 9165155945
              </a>
            </div>
          </div>
        </div>
        <span className="text-vertical">24/7 आपातकालीन सेवा</span>
        <ul className="dz-social">
          <li>
            <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
              <i className="fa-brands fa-facebook-f" />
            </Link>
          </li>
          <li>
            <a to="https://www.instagram.com" target="_blank">
              <i className="fa-brands fa-instagram" />
            </a>
          </li>

          <li>
            <a to="https://twitter.com" target="_blank">
              <i className="fa-brands fa-x-twitter" />
            </a>
          </li>
          <li>
            <a to="https://www.youtube.com" target="_blank">
              <i className="fa-brands fa-youtube" />
            </a>
          </li>
        </ul>
      </div>


      <section className="content-inner" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)', backgroundPosition: 'right bottom', backgroundRepeat: 'no-repeat' }}>
        <div className="container">
          <div className="row content-wrapper style-5">
            <div className="col-xxl-7 col-xl-6 col-lg-5 m-b30 align-self-center">
              <div className="content-info">
                <div className="section-head style-1 m-b30">
                  <h2 className="title wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'none' }}>अक्सर पूछे जाने वाले प्रश्नों</h2>
                  <p className="wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.7s" style={{ animationDuration: '0.7s', animationDelay: '0.4s', animationName: 'none' }}> ओमकार मल्टीस्पेशलिटी हॉस्पिटल में सभी मेडिकल सुविधाएँ एक ही छत के नीचे उपलब्ध हैं। यह 60 बिस्तरों वाला टर्शियरी केयर हॉस्पिटल है, जहाँ कई सुपर-स्पेशलिटी सेवाएँ दी जाती हैं। यह हॉस्पिटल आरंग में एक एकड़ की खूबसूरत ज़मीन पर स्थित है। यहाँ मिलने वाली अलग-अलग सेवाओं में शामिल हैं:</p>
                </div>
                <div className="accordion dz-accordion style-1" id="accordionExample">
                  <div className="accordion-item wow fadeInUp" data-wow-delay="0.5s" data-wow-duration="0.7s" style={{ animationDuration: '0.7s', animationDelay: '0.5s', animationName: 'none' }}>
                    <h2 className="accordion-header">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        ओंकार मल्टीस्पेशलिटी हॉस्पिटल कौन-कौन सी सेवाएँ देता है?
                        
                      </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        <p>सेवाओं का दायरा:- 24x7 इमरजेंसी</p>
                        <p>24x7 फार्मेसी</p>
                        <p>CTVS <br />
                          मेडिकल <br />
                          न्यूरो साइंस <br />
                          नियोनेटल (नवजात शिशु देखभाल) <br />
                          सर्जिकल <br />
                          प्लास्टिक सर्जरी <br />
                          कार्डियो-थोरेसिक वैस्कुलर सर्जरी <br />
                          कार्डियोलॉजी <br />
                          एंडोक्रिनोलॉजी <br />
                          गैस्ट्रो-इंटेस्टाइनल सर्जरी <br />
                          गैस्ट्रोएंटेरोलॉजी <br />
                          इंटरवेंशनल रेडियोलॉजी <br />
                          जनरल मेडिसिन <br />
                          जनरल सर्जरी <br />
                          ऑब्सटेट्रिक्स और गायनेकोलॉजी (प्रसूति और स्त्री रोग) <br />
                          ऑप्थल्मोलॉजी (नेत्र रोग विज्ञान) <br />
                          ऑर्थोपेडिक्स (हड्डी रोग विज्ञान) <br />
                          पीडियाट्रिक्स (बाल चिकित्सा) <br />
                          साइकियाट्री (मनोचिकित्सा) <br />
                          त्वचा और यौन रोग (Skin & V.D.) <br />
                          1.5 टेस्ला MRI <br />
                          64 स्लाइस CT स्कैन <br />
                          3.0 टेस्ला MRI <br />
                          कलर डॉपलर-4D <br />
                          मैमोग्राफी <br />
                          एक्स-रे <br />
                          एयर एम्बुलेंस <br />
                          डिजिटल पेमेंट <br />
                          एग्जीक्यूटिव हेल्थ-चेकअप <br />
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="col-xxl-5 col-xl-6 col-lg-7 m-b30">
              <div className="content-media skrollable skrollable-before" data-bottom-top="transform: translateY(50px)" data-top-bottom="transform: translateY(-50px)" style={{ transform: 'translateY(50px)' }}>
                <div className="dz-media">
                  <img src="./assets/img/Frequently Asked Questions.webp" alt />
                </div>
                <div className="item1">
                  <div className="info-widget style-5">
                    <div className="widget-media text-primary">
                      <i className="feather icon-phone-call dz-ring-effect" />
                    </div>
                    <div className="widget-content">
                      <h6 className="title">हमसे संपर्क करें</h6>
                      <a href="tel:+91 9165155945" className="text-secondary">+91 9165155945</a>
                    </div>
                  </div>
                  <Link to="/contact-us" className="btn btn-lg btn-icon btn-primary btn-shadow">
                    <span className="w-100">अपॉइंटमेंट</span> <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default Faq